import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useRedux } from "../../hooks/useRedux";
import { onFiscalFormation } from "../../redux/slices/clientInformation";
import Top from "../../components/templates/topV2";
import Spinner from "../../components/atoms/spinnerV2";
import listText from "../../utils/dictionaries/dictionary-fiscal-information-client";
import validationSchema from "./schema";
import Information from "./fiscal-information";
import ConfirmAddress from "./confirm-address";
import AlertData from "./confirmation";
import { useRFC } from "../../hooks/useRFC";
import { useApi } from "../../hooks/useApi";
import PERSONALDATA from "../../services/personalData.service";
import "./index";
import { useFollowLater } from "../../hooks/useFollowLater";
import { useModalError } from "../../hooks/useModalError";

export type TTypeTab = "contact-information" | "confirm-address" | "alert-data";

const { postFiscalInformation } = new PERSONALDATA();

const FiscalInformationClient = () => {
  const { modaComponente, setIsModalError } = useModalError();
  const navigate = useNavigate();
  const { onClickContinue } = useFollowLater();
  const {
    data: {
      clientInformation,
      clientPersist: { uuid },
    },
    dispatch,
  } = useRedux();
  const { dataRfcByPerson, errorRfcByPerson, isLoadingRfcByPerson } = useRFC();
  const {
    data: dataFiscalInformation,
    error: errorFiscalInformation,
    execute: executeFiscalInformation,
    isLoading: isLoadingFiscalInformation,
  } = useApi(postFiscalInformation);

  const [view, setView] = useState<TTypeTab>("contact-information");

  const formik = useFormik({
    initialValues: {
      valueRFC: clientInformation.fiscalFormation.valueRFC,
      homoclave: clientInformation.fiscalFormation.homoclave,
      addressMatch: clientInformation.fiscalFormation.addressMatch,
      regimenFiscal: clientInformation.fiscalFormation.regimenFiscal,
      fiscalRegimeKey: clientInformation.fiscalFormation.fiscalRegimeKey,
      confirmAddress: {
        zipCode: clientInformation.fiscalFormation.confirmAddress?.zipCode
          ? clientInformation.fiscalFormation.confirmAddress.zipCode
          : "",
        state: clientInformation.fiscalFormation.confirmAddress?.state
          ? clientInformation.fiscalFormation.confirmAddress.state
          : "",
        stateId: clientInformation.fiscalFormation.confirmAddress?.stateId
          ? clientInformation.fiscalFormation.confirmAddress.stateId
          : "",
        township: clientInformation.fiscalFormation.confirmAddress?.township
          ? clientInformation.fiscalFormation.confirmAddress.township
          : "",
        townshipId: clientInformation.fiscalFormation.confirmAddress?.townshipId
          ? clientInformation.fiscalFormation.confirmAddress.townshipId
          : "",
        suburbs: clientInformation.fiscalFormation.confirmAddress?.suburbs
          ? clientInformation.fiscalFormation.confirmAddress.suburbs
          : "",
        street: clientInformation.fiscalFormation.confirmAddress?.street
          ? clientInformation.fiscalFormation.confirmAddress.street
          : "",
        outsideNumber: clientInformation.fiscalFormation.confirmAddress?.outsideNumber
          ? clientInformation.fiscalFormation.confirmAddress.outsideNumber
          : "",
        internalNumber: clientInformation.fiscalFormation.confirmAddress?.internalNumber
          ? clientInformation.fiscalFormation.confirmAddress.internalNumber
          : "",
      },
    },
    validationSchema: validationSchema,
    onSubmit: (values) => console.log(values),
  });

  useEffect(() => {
    if (
      dataRfcByPerson.homoclave &&
      dataRfcByPerson.rfc &&
      !isLoadingRfcByPerson &&
      !errorRfcByPerson
    ) {
      formik.setFieldValue("valueRFC", dataRfcByPerson.rfc);
      formik.setFieldValue("homoclave", dataRfcByPerson.homoclave);
    }
  }, [dataRfcByPerson, isLoadingRfcByPerson, errorRfcByPerson]);

  const onOk = () => {
    if (formik.values.addressMatch === "no") {
      dispatch(onFiscalFormation({ ...formik.values }));
      return setView("confirm-address");
    } else {
      executeFiscalInformation({ fiscalFormation: formik.values, processId: uuid });
      dispatch(onFiscalFormation({ ...formik.values }));

      if (!dataFiscalInformation?.validateSAT && errorFiscalInformation && !isLoadingFiscalInformation) {
        setIsModalError(true);
      } else {
        if (!dataFiscalInformation?.validateSAT && !isLoadingFiscalInformation) {
          return setView("alert-data");
        } else if (dataFiscalInformation?.validateSAT && !isLoadingFiscalInformation) {
          navigate("/LaborInformation");
        }
      }

    }
    onClickContinue({
      data: formik.values,
      processId: uuid,
      resource: "FiscalInformationClient",
      step: "CONTINUE",
    });
  };

  const onOkConfirmAddress = () => {
    dispatch(onFiscalFormation({ ...formik.values }));
    executeFiscalInformation({ fiscalFormation: formik.values, processId: uuid });
    if (errorFiscalInformation && !isLoadingFiscalInformation) {
      setIsModalError(true);
    } else {
      if (!dataFiscalInformation?.validateSAT && !isLoadingFiscalInformation) {
        return setView("alert-data");
      } else if (dataFiscalInformation?.validateSAT && !isLoadingFiscalInformation) {
        navigate("/LaborInformation");
      }
    }

  };

  const onClickButtonLink = () => {
    navigate("/FollowLater", {
      state: {
        processId: uuid,
        resource: "/FiscalInformationClient",
        step: "CONTINUE_AFTER",
        data: formik.values,
      },
    });
    dispatch(onFiscalFormation({ ...formik.values }));
  };

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={listText.top.titleHeader}
          subTitle={!["alert-data"].includes(view) ? listText.top.subTitle : ""}
          displayLeftImageTitle={
            !["alert-data", "contact-information"].includes(view) ? "d-block" : "d-none"
          }
          displayProgressBar={["alert-data"].includes(view) ? "d-none" : "d-block"}
          classHeader={"mt-2"}
          classProgressBar={"mt-3"}
          valueProgressBar={"50%"}
          onClickGoBackIcon={() => setView("contact-information")}
        />
        {isLoadingFiscalInformation ? (
          <Spinner />
        ) : (
          <>
            {view === "contact-information" && <Information isLoadingFiscalInformation={isLoadingFiscalInformation} onClickButtonLink={onClickButtonLink} onOk={onOk} formik={formik} />}
            {view === "confirm-address" && (
              <ConfirmAddress isLoadingFiscalInformation={isLoadingFiscalInformation} setView={onOkConfirmAddress} formik={formik} />
            )}
            {view === "alert-data" && (
              <AlertData isLoadingFiscalInformation={isLoadingFiscalInformation} setView={() => navigate("/LaborInformation")} />
            )}
          </>
        )}
      </div>
      {modaComponente}
    </>
  );
};

export default FiscalInformationClient;